import * as React from 'react';
import Grid from '@mui/material/Grid';

import Moment from 'react-moment';

import ReactJson from 'react-json-view'

import { Typography } from '@mui/material';
import Modal from '@mui/material/Modal';
import Paper from '@mui/material/Paper';
import CloseIcon from '@mui/icons-material/Close';

import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import ListItemAvatar from '@mui/material/ListItemAvatar';
import ListItemIcon from '@mui/material/ListItemIcon';
import Avatar from '@mui/material/Avatar';
import Link from '@mui/material/Link';
import BrushIcon from '@mui/icons-material/Brush';
import OpenInNewIcon from '@mui/icons-material/OpenInNew';
import NaturePeopleIcon from '@mui/icons-material/NaturePeople';
import NatureIcon from '@mui/icons-material/Nature';
import EventIcon from '@mui/icons-material/Event';
import PublicIcon from '@mui/icons-material/Public';
import PhotoSizeSelectActualIcon from '@mui/icons-material/PhotoSizeSelectActual';
import CropOriginalIcon from '@mui/icons-material/CropOriginal';
import BadgeIcon from '@mui/icons-material/Badge';


const ModalStyle = {
    position: 'absolute' as 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: '95%',
    maxWidth: '900px',
    height: '80%',
    bgcolor: 'background.paper',
    boxShadow: 24,
    p: 4,
    borderRadius: "1.5rem",
    '::-webkit-scrollbar': { width: 0, height: 0 }
};

class NFTreeModal extends React.Component<any, any> {

    render() {
        return <Modal open={this.props.open} onClose={this.props.handleClose}>
        <Paper elevation={3} sx={ModalStyle} style={{overflowX:"hidden", overflowY:"scroll", scrollbarWidth:"none"}}>
            <Grid container spacing={2} >
            <Grid item xs={11} sx={{textAlign:"center"}}>
                <Typography id="modal-modal-title" variant="h4" component="h2">
                    Digital Certificate details
                </Typography>
            </Grid>
            <Grid item xs={1}>
                <CloseIcon style={{float:"right", fontSize:32}} onClick={this.props.handleClose}/>
            </Grid>
            <Grid item xs={12} md={6}>
              This Digital Certificate has been created by Bloomeria in cooperation with {" "}
              <Link href={this.props.metadata.external_url} target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>RMTerra</Link>.
              <List sx={{ width: '100%', maxWidth: 360, bgcolor: 'background.paper' }}>

              <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <NaturePeopleIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={"Planted by RMTerra"} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    <ListItemIcon>
                      <Link href="https://www.rmterra.org/" target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                        <OpenInNewIcon />
                      </Link>
                    </ListItemIcon>
                </ListItem>


                <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <NatureIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={<span><span>Tree specie: </span> {this.props.metadata.attributes[0].value} </span>} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    
                </ListItem>

                <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <EventIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={<span><span>Planted on</span> <Moment unix format="YYYY/MM/DD">{this.props.metadata.attributes[1].value}</Moment> </span>} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    
                </ListItem>

                <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <BadgeIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={<span><span>Digital Certificate name: </span> {this.props.metadata.name} </span>} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    
                </ListItem>

                <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <PhotoSizeSelectActualIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={"Original tree pîcture on IPFS"} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    <ListItemIcon>
                      <Link href={"https://ipfs.io/ipfs/" + this.props.metadata.tree_picture_ipfs.split("ipfs://")[1]} target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                        <OpenInNewIcon />
                      </Link>
                    </ListItemIcon>
                </ListItem>

                <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <BrushIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={"Art by " + this.props.metadata.attributes[2]['value']} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    <ListItemIcon>
                      <Link href={this.props.metadata['Artist website']} target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                        <OpenInNewIcon />
                      </Link>
                    </ListItemIcon>
                </ListItem>

                <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <CropOriginalIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={"Original art image on IPFS"} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    <ListItemIcon>
                      <Link href={"https://ipfs.io/ipfs/" + this.props.metadata.image.split("ipfs://")[1]} target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                        <OpenInNewIcon />
                      </Link>
                    </ListItemIcon>
                </ListItem>

                <ListItem>
                  <ListItemAvatar sx={{marginLeft:-2}}>
                    <Avatar>
                      <PublicIcon />
                    </Avatar>
                  </ListItemAvatar>
                  <ListItemText primary={"Metadata stored on IPFS"} secondary={""} sx={{overflow: 'hidden',textOverflow: 'ellipsis' }} />
                    <ListItemIcon>
                      <Link href={"https://ipfs.io/ipfs/" + this.props.uri.split("ipfs://")[1]} target="_blank" sx={{color:(theme)=>theme.palette.info.main}}>
                        <OpenInNewIcon />
                      </Link>
                    </ListItemIcon>
                </ListItem>
              </List>
            </Grid>
            <Grid item xs={12} md={6} sx={{margin:"auto"}}>
              <img 
                src={this.props.getURL(this.props.metadata.image, 600, 400)} 
                style={{width:"100%", maxWidth:400, marginRight:"auto", marginLeft:"auto", display:"block"}} 
                alt=""
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <img 
                src={this.props.getURL(this.props.metadata.tree_picture_ipfs, 400, 400)} 
                style={{width:"100%", maxWidth:400, marginRight:"auto", marginLeft:"auto", display:"block"}} 
                alt=""
              />
            </Grid>
            <Grid item xs={12} md={6}>
              <p>Complete metadata:</p>
              <ReactJson 
                src={this.props.metadata}
                collapsed={true}
                enableClipboard={false} 
                displayDataTypes={false} 
                indentWidth={2}
                style={{overflow: 'hidden',textOverflow: 'ellipsis' }}
              />
            </Grid>
          </Grid>
        </Paper>
          
      </Modal>
        
    }
}

export default NFTreeModal